export enum exclusionsModalEvents {
    SHOW_EXCLUSIONS = 'exclusionsModal/show',
    HIDE_EXCLUSIONS = 'exclusionsModal/hide',
    LOAD_EXCLUSIONS = 'exclusionsModal/load',
}

const showExclusionsModal = function () {
    const event = new CustomEvent(exclusionsModalEvents.SHOW_EXCLUSIONS);
    window.dispatchEvent(event);
};

const loadExclusionsModal = function () {
    const event = new CustomEvent(exclusionsModalEvents.LOAD_EXCLUSIONS);
    window.dispatchEvent(event);
};

const hideExclusionsModal = function () {
    window.dispatchEvent(new CustomEvent(exclusionsModalEvents.HIDE_EXCLUSIONS));
};

export default {
    showExclusionsModal,
    hideExclusionsModal,
    loadExclusionsModal,
};
